module.exports = __webpack_public_path__ + "static/media/facebook.ec26aaac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/images/facebook.svg
// module id = 50
// module chunks = 19